import { BASE_ASSETS } from "@assets/templates/constants";
import type { TemplateDefinition } from "@assets/templates/types";
import { DocumentInputContentV1 } from "@demo/types/documentContent";

export const agricultureFruits: TemplateDefinition = {
  mode: "compose",
  slug: "agriculture-fruits",
  version: 1,
  title: "Agriculture",
  description: "Categorize objects",
  thumbnailUuid: BASE_ASSETS.fruit.uuid,
  assets: [BASE_ASSETS.fruit],
  request: {
    model: "perceptron-mk1.5",
    system: [],
    user: [
      {
        type: "media",
        value: [
          {
            type: "image",
            value: {
              uuid: BASE_ASSETS.fruit.uuid,
              extension: BASE_ASSETS.fruit.extension,
              annotations: { points: [], boundingBoxes: [] },
            },
          },
        ],
      },
      {
        type: "paragraph",
        value: {
          type: "text",
          value: "Point at any ripe fruit.",
        },
      },
    ],
    outputAnnotations: false,
    variables: {},
    annotationFormat: "box",
    enableThinking: false,
  } satisfies DocumentInputContentV1,
};
